<template>
    <v-col cols="12" class="px-8" v-if="permisoVista('dashboard','r')">
      <template v-if="!modoProyeccion ">
        <v-row class="mt-0">
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
              v-model="filtros.desde"
                  format="YYYY-MM-DD"
                  label="Desde (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :maxDate="filtros.hasta"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4" class="align-self-end">
            <!-- @input="obtenerDatos" -->
            <datePicker
            v-model="filtros.hasta"
                  format="YYYY-MM-DD"
                  label="Hasta (Obligatorio)"
                  clearable
                  maxToday
                  
                  :disabled="cargando"
              :minDate="filtros.desde"
                ></datePicker>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <!-- <v-autocomplete
              v-model="filtros.idsTurnos"
              :items="turnos"
              item-value="idTurno"
              item-text="nombre"
              label="Turnos (Opcional)"
              hide-details
              clearable
              multiple
              chips
              deletable-chips
              :disabled="cargando"
              @input="obtenerDatos"
              @click:clear="resetCampo(1)"
            >
            </v-autocomplete> -->
            <!-- @input="obtenerDatos" -->
            <v-autocomplete
              v-model="filtros.idsTurnos"
              :items="turnos"
              item-value="idTurno"
              item-text="nombre"
              label="Turnos (Opcional)"
              hide-details
              clearable
              multiple
              chips
              deletable-chips
              :disabled="cargando"
              
              @click:clear="resetCampo(1)"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-target</v-icon> Filtros Avanzados (Opcionales)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsAreas"
                      :items="areas"
                      item-value="idArea"
                      item-text="nombre"
                      label="Áreas"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(2)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsOTS"
                      :items="ots"
                      item-value="idTrabajoOrden"
                      item-text="clave"
                      label="Orden de Trabajo"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(3)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsArticulos"
                      :items="articulos"
                      item-value="idArticulo"
                      :item-text="nombreArticulo"
                      label="Artículos"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(4)"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsMaquinaInstancias"
                      :items="maquinasIns"
                      item-value="idMaquinaIns"
                      :item-text="nombreMaquina"
                      label="Maquinas Instancias"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(5)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsPersonas"
                      :items="operadores"
                          item-value="idPersona"
                          :item-text="nombrePersona"
                      label="Personas"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(6)"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="4" md="4" sm="4">
                    <!-- @input="obtenerDatos" -->
                    <v-autocomplete
                      v-model="filtros.idsClientes"
                      :items="clientes"
                      item-text="nombre"
                      item-value="idCliente"
                      label="Clientes"
                      hide-details
                      clearable
                      multiple
                      chips
                      deletable-chips
                      :disabled="cargando"
                      
                      @click:clear="resetCampo(7)"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
        <v-row>
            <v-btn color="primary" dark class="mb-2" @click="obtenerDatos">Consultar</v-btn>
            
            <!--<download-btn
              className="my-4"
              color="blue darken-1"
              text
              @click="descargarReporte"
              label="Descargar Reporte de OEE"
            />-->

            <download-btn
              className="my-4"
              color="green darken-1"
              text
              :disabled="!realizarPeticion || cargandoHF"
              :loading="cargandoHF"
              @click="generarReporteDetalladoHF"
              label="Generar Reporte OEE Detallado"
            />

            <v-snackbar
              v-model="snackbarHF"
              :color="snackbarColorHF"
              :timeout="4000"
              top
              right
            >
              {{ snackbarTextHF }}
            </v-snackbar>
        </v-row>
        <br>
      </template>
      <div v-if="viewData ">
        <v-row v-if="realizarPeticion && sameDay" class="px-0 ma-0">
        <v-col cols="12" class="ma-0 text-right text-subtitle-2 d-flex flex-column">
          Proxima Actualización en {{tiempo}}
          <div v-if="!modoProyeccion" class="text-right d-flex my-n5">
            <div class="ml-auto">
              <v-switch v-model="switch1"
               label="Desactivar actualización automática"
               @change="stopTimer"
              ></v-switch>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- Apartado donde veremos los promedios de los datos -->
          <v-row v-if="!cargando"class="justify-center ma-0 pa-0" >
            <v-data-table
                  :headers="headers"
                  :items="datos"
                  item-key="id"
                  fixed-header
                  height="600px"
                  
                >
                  <template v-slot:[`item.tiempoNeto`]="{ item }">
                    {{$utils.strings.toTime(item.tiempoNeto)}}
                  </template>
                  <template v-slot:[`item.tiempoBruto`]="{ item }">
                    {{$utils.strings.toTime(item.tiempoBruto)}}
                  </template>
                  <template v-slot:[`item.tiempoParos`]="{ item }">
                    {{$utils.strings.toTime(item.tiempoParos*3600)}}
                  </template>
                  <template v-slot:[`item.tiempoMuerto`]="{ item }">
                    {{item.tiempoMuerto}} min
                  </template>
                  <template v-slot:[`item.disponibilidad`]="{ item }">
                    {{(item.disponibilidad).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.eficiencia`]="{ item }">
                    {{(item.eficiencia).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.calidad`]="{ item }">
                    {{(item.calidad).toFixed(2)}}%
                  </template>
                  <template v-slot:[`item.oee`]="{ item }">
                    {{(item.oee).toFixed(2)}}%
                  </template>
                  <!-- <template v-slot:[`item.maquinas`]="{ item }">
                    <ul>
                      <li v-for="(m,idx) in item.maquinas" :key="'m-'+idx">{{m}}</li>
                    </ul>
                  </template>
                  <template v-slot:[`item.personas`]="{ item }">
                    <ul>
                      <li v-for="(p,idx) in item.personas" :key="'p-'+idx">{{p}}</li>
                    </ul>
                  </template>                   -->
                </v-data-table>
          </v-row>
      <!-- En el caso de que desde y hasta sean iguales, se muentran el promedio de los turnos de ese dia v-for="item in datos.resumenTurno"-->
      
      <!-- Graficas -->
     
      
      </div>
      <div v-if="cargandoData ">
        <v-col cols="12" md="12" sm="12" class="text-center">
                          <h4>Cargando</h4>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="text-center">
                          <v-progress-circular
                              :size="75"
                              color="green"
                              indeterminate
                          ></v-progress-circular>
                      </v-col>
      </div>

    </v-col>
  </template>
    
  <script>
  import { mapState } from 'vuex';
  import axios from "axios";
  import ICountUp from "vue-countup-v2";
  import moment from "moment";
  import DownloadBtn from '../../DownloadBtn.vue';
  import Velocimetro from '../../Velocimetro.vue';
  
  export default {
      components: {
          ICountUp,
      DownloadBtn,
      Velocimetro
      },
    props: {
      modoProyeccion: {
        type: Boolean,
        default: false
      },
      update: {
        type: Number,
        default: 5
      },
          active: {
              type: Boolean,
              default: false,
          },
      },
      computed: {
      idTurnoActual(){
        const currentTime = new Date();
        const turnoActual = this.turnos.find(turno => {
          const start = this.$utils.strings.stringToTime(turno.inicio);
          const end = this.$utils.strings.stringToTime(turno.fin);
          // Manejar el caso en que el rango cruce la medianoche
          if (start > end) {
            return currentTime >= start || currentTime <= end;
          } else {
            return currentTime >= start && currentTime <= end;
          }
        });
        return turnoActual?.idTurno || null;
      },
      today(){
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
      },
      ...mapState({
        nombreEmpresa: 'nombreEmpresa',
        oeeRendimientoLabel: 'oeeRendimientoLabel',
        nuevoReporteOee: 'nuevoReporteOee',
        formulaNyx: 'formulaNyx',
      }),
          realizarPeticion() {
              return this.$utils.isValid(this.filtros.desde) && this.$utils.isValid(this.filtros.hasta);
          },
          url() {
        //Como el endpoint cambia dependiendo de la variable de entorno, se hace una validacion para que tome el correcto
        var endpoint = this.formulaNyx? 'OEEDetalladoNyx' : 'OEEDetalladoGlm';//OEERangoTurnosNyx
        var url = `/OEEV2/${endpoint}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
        /* url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false); */
        if(this.filtros.idsTurnos != null)
          url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
        
        url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
        return url;
          },
          tiempo(){
        return this.$utils.strings.toTime(this.segundos);
      },
      sameDay(){
        var desde = this.$utils.isValid(this.filtros.desde) ? moment(this.filtros.desde, "YYYY-MM-DD") : moment(1);
        var hasta = this.$utils.isValid(this.filtros.hasta) ? moment(this.filtros.hasta, "YYYY-MM-DD") : moment(1);
        return desde.isSameOrAfter(moment(),'day') || hasta.isSameOrAfter(moment(),'day');
      },

      // Variable temporal para controlar el desplegado de traficas simulando el OEE
      arielrNYX() {
        if(this.nombreEmpresa == 'Nyx' || this.nombreEmpresa == 'Glm') {
          return false
        }
        return true
      },
      },
      data(){
      return {
        cargandoHF: false,
        snackbarHF: false,
        snackbarTextHF: '',
        snackbarColorHF: 'success',
        seriesDisponibilidad: null,
        seriesBackDisponibilidad: null,
        seriesRendimiento: null,
        seriesBackRendimiento: null,
        seriesCalidad: null,
        seriesBackCalidad: null,
        seriesOee: null,
        seriesBackOee: null,
        datosBack : null,
        filtroDDisponibilidad:null ,
        filtroHDisponibilidad:null ,
        filtroDRendimiento:null ,
        filtroHRendimiento:null ,
        filtroDCalidad:null ,
        filtroHCalidad:null ,
        filtroDOee:null ,
        filtroHOee:null ,
        switch1: true,
        efode: false,
        efore: false,
        efoce: false,
        efoee: false,
      resumenHorasHeaders: [
        {
          text: "Dia",
          align: "center",
          value: "fecha"
        },
        {
          text: "Maquina",
          align: "center",
          value: "maquina"
        },
        {
          text: "Turno",
          align: "center",
          value: "turno"
        },
        {
          text: "Desde",
          align: "center",
          value: "desdeHora"
        },
        {
          text: "Hasta",
          align: "center",
          value: "hastaHora"
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          value: "pzaTeoricas"
        },
        {
          text: "Total de piezas",
          align: "center",
          value: "pzaRealizadas"
        },
        {
          text: "Piezas No Ok",
          align: "center",
          value: "pzaNoOk"
        },
        {
          text: "TiempoMuerto",
          align: "center",
          value: "tiempoParo"
        },
        {
          text: "OEE",
          align: "center",
          value: "oee"
        },
        // { text: '', value: 'data-table-expand' },
      ],
      cargandoData:false,
      viewData:false,
      contador: 8,
          interval: null,
          segundos: 60,
          cargando: false,
      expanded: [],
      expanded1: [],
      filtros: {
        desde: null,
        hasta: null,
        idsTurnos: [],
        idsAreas: [],
        idsOTS: [],
        idsArticulos: [],
        idsMaquinaInstancias: [],
        idsPersonas: [],
        idsClientes: []
      },
      turnos:[],
      areas:[],
      ots:[],
      articulos:[],
      maquinasIns:[],
      operadores:[],
      clientes:[],
      datos:[],
      datosDefault:[],
      serie1: [],
      chartOptions1:{
        chart: {
          id: 'disponibilidad',
          group: 'oee',
          type: 'line',
          height: 160,
          toolbar: {
            show: false
          },
        },
        dataLabels: {
            enabled: false, // Ocultar los valores de la serie
          },
        colors: ['#118dff'],
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie2: [],
      chartOptions2:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'line',
          height: 160,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#ff8410'],
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie3: [],
      chartOptions3:{
        chart: {
          id: 'calidad',
          group: 'oee',
          type: 'line',
          height: 160,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#10ff60'],
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie4: [],
      chartOptions4:{
        chart: {
          id: 'OEE',
          group: 'oee',
          type: 'line',
          height: 160,
          toolbar: {
            show: false
          },
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series[seriesIndex][dataPointIndex];
              return '<div style="padding: 8px;">' +
                `<span>${data.x}</span><br>` +
                `<span>Valor Y: ${data.y}</span>` +
                '</div>';
            },
          },
        colors: ['#ff372b'],
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie5: [],
      chartOptions5:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#118dff'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie6: [],
      chartOptions6:{
        chart: {
          id: 'rendimiento',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#ff8410'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        },
      },
      serie7: [],
      chartOptions7:{
        chart: {
          id: 'calidad',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        colors: ['#6B8E23'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },
      serie8: [],
      chartOptions8:{
        chart: {
          id: 'OEE',
          group: 'oee',
          type: 'bar',
          height: 220,
          toolbar: {
            show: false
          },
          events: {
            click: function(event, chartContext, config) {
                console.log("funciona")
            }
          }
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              const data = series[seriesIndex][dataPointIndex];
              return '<div style="padding: 8px;">' +
                `<span>${data.x}</span><br>` +
                `<span>Valor Y: ${data.y}</span>` +
                '</div>';
            },
          },
        colors: ['#ff372b'],
        xaxis: {
          type: 'string',
          labels: {
            // datetimeUTC: false
          },
          tooltip: {
            enabled: true,
          }
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)+'%';
            }
          },
          min: 0,
          tickAmount: 5,
        }
      },

      renderizar: false,
      headers:[
        {
          text: "Fecha",
          align: "center",
          sortable: false,
          value: "fecha",
          // width: "50%",
        },
        {
          text: "Turno",
          align: "center",
          sortable: false,
          value: "turno",
          // width: "50%",
        },
        {
          text: "Maquina",
          align: "center",
          sortable: false,
          value: "maquina",
          // width: "50%",
        },
        {
          text: "Piezas Ok",
          align: "center",
          sortable: false,
          value: "piezasOk",
          // width: "50%",
        },
        {
          text: "Piezas No Ok",
          align: "center",
          sortable: false,
          value: "piezasNoOk",
          // width: "50%",
        },        
        {
          text: "Piezas Totales",
          align: "center",
          sortable: false,
          value: "totalPiezas",
          // width: "50%",
        },
        {
          text: "Tiempo Total",
          align: "center",
          sortable: false,
          value: "tiempoNeto",
          // width: "50%",
        },
        {
          text: "Tiempo Evaluado",
          align: "center",
          sortable: false,
          value: "tiempoBruto",
          // width: "50%",
        },
        {
          text: "Tiempo Muerto",
          align: "center",
          sortable: false,
          value: "tiempoMuerto",
          // width: "50%",
        },
        {
          text: "Piezas por hora esperadas",
          align: "center",
          sortable: false,
          value: "piezasXHoraTeoricas",
          // width: "50%",
        },
        {
          text: "Piezas por hora reportadas",
          align: "center",
          sortable: false,
          value: "piezasXHoraReport",
          // width: "50%",
        },
        {
          text: "Disponibilidad",
          align: "center",
          sortable: false,
          value: "disponibilidad",
          // width: "50%",
        },
        {
          text: "Rendimiento",
          align: "center",
          sortable: false,
          value: "eficiencia",
          // width: "50%",
        },
        {
          text: "Calidad",
          align: "center",
          sortable: false,
          value: "calidad",
          // width: "50%",
        },
        {
          text: "OEE",
          align: "center",
          sortable: false,
          value: "oee",
          // width: "50%",
        },
      ],
      headersXDia:[
        {
          text: "Día",
          align: "center",
          sortable: false,
          value: "inicioString",
          // width: "50%",
        },        
        {
          text: "Tiempo Evaluado",
          align: "center",
          sortable: false,
          value: "tiempoBruto",
          // width: "50%",
        },
        {
          text: "Tiempo Activo",
          align: "center",
          sortable: false,
          value: "tiempoNeto",
          // width: "50%",
        },
        {
          text: "STD",
          align: "center",
          sortable: false,
          value: "std",
          // width: "50%",
        },
        {
          text: "Total Piezas",
          align: "center",
          sortable: false,
          value: "totalPiezas",
          // width: "50%",
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          sortable: false,
          value: "piezasTeoricas",
          // width: "50%",
        },
        {
          text: "Piezas Ok",
          align: "center",
          sortable: false,
          value: "piezasOk",
          // width: "50%",
        },
        {
          text: "Piezas No Ok",
          align: "center",
          sortable: false,
          value: "piezasNoOk",
          // width: "50%",
        },
        {
          text: "Paros",
          align: "center",
          sortable: false,
          value: "reportes",
          // width: "50%",
        },
        {
          text: "Scrap",
          align: "center",
          sortable: false,
          value: "scrap",
          // width: "50%",
        },
        { text: '', value: 'data-table-expand' },
      ],
      headersXMaquina:[
        {
          text: "Día",
          align: "center",
          sortable: false,
          value: "fecha",
          // width: "50%",
        },        
        {
          text: "Máquina(s)",
          align: "center",
          sortable: false,
          value: "maquina",
          // width: "50%",
        },
        {
          text: "Turno",
          align: "center",
          sortable: false,
          value: "turno",
          // width: "50%",
        },
        {
          text: "Tiempo Muerto",
          align: "center",
          sortable: false,
          value: "tiempoMuerto",
          // width: "50%",
        },
        // {
        //   text: "Tiempo Evaluado",
        //   align: "center",
        //   sortable: false,
        //   value: "tiempoBruto",
        //   // width: "50%",
        // },
        // {
        //   text: "Tiempo Activo",
        //   align: "center",
        //   sortable: false,
        //   value: "tiempoNeto",
        //   // width: "50%",
        // },
        // {
        //   text: "STD",
        //   align: "center",
        //   sortable: false,
        //   value: "std",
        //   // width: "50%",
        // },
        {
          text: "Total Piezas",
          align: "center",
          sortable: false,
          value: "totalPiezas",
          // width: "50%",
        },
        {
          text: "Piezas Teoricas",
          align: "center",
          sortable: false,
          value: "piezasTeoricas",
          // width: "50%",
        },
        {
          text: "Piezas Ok",
          align: "center",
          sortable: false,
          value: "piezasOk",
          // width: "50%",
        },
        {
          text: "Piezas No Ok",
          align: "center",
          sortable: false,
          value: "piezasNoOk",
          // width: "50%",
        },
        {
          text: "Paros",
          align: "center",
          sortable: false,
          value: "reportes",
          // width: "50%",
        },
        {
          text: "Scrap",
          align: "center",
          sortable: false,
          value: "scrap",
          // width: "50%",
        },
        { text: '', value: 'data-table-expand' },
      ],
      countVel:0,
      }
    },
      methods: {
      async generarReporteDetalladoHF () {
        if (!this.realizarPeticion || this.cargandoHF) return;

        this.cargandoHF = true;

        const url = this.url2('/OEEV2/OEEReportDetalladoHF');

        try {
          const resp = await axios.get(url);

          // Mensaje de éxito
          this.snackbarTextHF =
            resp.data ||
            'La generación del reporte detallado ha sido enviada al servidor. ' +
            'Te aparecerá una notificación cuando esté listo.';
          this.snackbarColorHF = 'success';
          this.snackbarHF = true;
        } catch (error) {
          console.error(error);

          this.snackbarTextHF =
            'No se pudo enviar la generación del reporte. Intenta de nuevo.';
          this.snackbarColorHF = 'error';
          this.snackbarHF = true;
        } finally {
          this.cargandoHF = false;
        }
      },
      nombreArticulo:(articulo) => `[${articulo.codigo}] - ${articulo.nombre}`,
      nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
      nombrePersona: (persona) => persona.nombre + " " + persona.paterno + " " + persona.materno,
      getRoundedHour(date) {
        // Crear una nueva fecha con la misma hora pero los minutos y segundos ajustados a 0
        const roundedDate = new Date(date);
        roundedDate.setMinutes(0, 0, 0);
        return roundedDate.getTime();
      },
      generarSerie(nombre, campo){
        var serie = {
          name: nombre,
          data: []
        };
  
        if(this.datos.resumenDias != null && this.datos.resumenDias.length > 0){
          serie.data = this.datos.resumenDias.map(d =>{
            var fechaFormateada = this.formatoFechaHora(d.fecha);
            var dateObject = new Date(fechaFormateada);
            return {
              z: dateObject,
              x: d.fecha,
              y: (this.nuevoReporteOee?d[campo]:d[campo]* 100 ),//
            }
          });
        }
     
        if(nombre =="Disponibilidad")
          this.seriesDisponibilidad = [serie];
        
        if(nombre =="Rendimiento")
          this.seriesRendimiento = [serie];
        
        if(nombre =="Calidad")
          this.seriesCalidad = [serie];
  
        if(nombre =="OEE")
          this.seriesOee = [serie];
        
        return [serie]; 
      },
      generarSerieTurno(nombre, campo){
        var serie = {
          name: nombre,
          data: []
        };
  
        if(this.datos.resumenTurno != null && this.datos.resumenTurno.length > 0){
          serie.data = this.datos.resumenTurno.map(d =>{
            // var fechaFormateada = this.formatoFechaHora(d.fecha);
            // var dateObject = new Date(fechaFormateada);
            return {
              z: d[campo],
              x: d.turno,
              y: (this.nuevoReporteOee?d[campo]:d[campo]* 100 ),//
            }
          });
        }
     
        // if(nombre =="Disponibilidad")
        //   this.seriesDisponibilidad = [serie];
        
        // if(nombre =="Rendimiento")
        //   this.seriesRendimiento = [serie];
        
        // if(nombre =="Calidad")
        //   this.seriesCalidad = [serie];
  
        // if(nombre =="OEE")
        //   this.seriesOee = [serie];
        
        return [serie]; 
      },
      formatoFechaHora(fecha) {
         const fechaObj = new Date(fecha);
         const dia = String(fechaObj.getDate()).padStart(2, '0');
         const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
          const anio = fechaObj.getFullYear();
          const horas = String(fechaObj.getHours()).padStart(2, '0');
          const minutos = String(fechaObj.getMinutes()).padStart(2, '0');
  
          return new Date(anio, mes - 1, dia, horas, minutos);
      },
      chartOptionsGenerador(id,color = '#008FFB'){
        if(this.datos.operacionesCant == 0){
          return {
            chart: {
              id: id,
              group: 'oee',
              type: 'line',
              height: 220,
              toolbar: {
                show: false
              },
              zoom: {
                enabled: false
              }
            },
            colors: [color],
            xaxis: {
              type: 'datetime' ,
              labels: {
                datetimeUTC: false,
              },
              tooltip: {
                enabled: false,
               
              },
            },
            yaxis: {
              labels: {
                formatter: function (val) {
                  return val.toFixed(2)+'%';
                }
              },
              min: 0,
              tickAmount: 5,
            },
          };

        }
        const start = moment(this.filtros.desde,"YYYY-MM-DD");
        const end = moment(this.filtros.hasta,"YYYY-MM-DD");
        const diferenciaDias = Math.abs(moment.duration(start.diff(end)).asDays());
        const soloHoras = diferenciaDias <= 1;
        let actualDay = false;
        if(this.filtros.desde == this.filtros.hasta){
          const today = (new Date()).toISOString().split('T')[0];
          actualDay = today == this.filtros.desde;
        }
        
        return  {
          chart: {
            id: id,
            group: 'oee',
            type: 'line',
            height: 220,
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            }
          },
          colors: [color],
          xaxis: {
            type: 'datetime' ,
            max: actualDay ? this.getRoundedHour(new Date()) : undefined,
            labels: {
              // formatter: (value) => moment(value).format("YYYY-MM-DD HH:mm"),
              format: soloHoras ? "HH:mm" : "yyyy-MM-dd HH:mm",
              datetimeUTC: false,
            },
            tooltip: {
              enabled: false,
             
            },
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(2)+'%';
              }
            },
            min: 0,
            tickAmount: 5,
          },
          tooltip: {
            x: {
              formatter: (value) => {
                //console.log("value "+value)
                return moment(value).format("YYYY-MM-DD HH:mm");
              }
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
              var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
              return '<div style="padding: 8px;">' +
                `${moment(data.x).format("YYYY-MM-DD HH:mm")}<br>` +
                `${w.globals.chartID}: <b>${(data.y).toFixed(2)}%</b>` +
                '</div>';
            },
          }
        };
      },
      chartOptionsGeneradorTurno(id,color){
        
        return  {
          chart: {
            id: id,
            group: 'oee',
            type: 'bar',
            height: 160,
            toolbar: {
              show: false
            },
          },
          tooltip: {
              custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const data =  w.globals.initialSeries[seriesIndex].data[dataPointIndex];//series[seriesIndex][dataPointIndex];
                
                return '<div style="padding: 8px;">' +
                  `<span>${data.x}</span><br>` +
                  `<span> ${data.y}</span>` +
                  '</div>';
              },
            },
          colors: [color],
          xaxis: {
            type: 'string',
            labels: {
              // datetimeUTC: false
            },
            tooltip: {
              enabled: true,
            }
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(2)+'%';
              }
            },
            min: 0,
            tickAmount: 5,
          }
        };
      },
      filtrarData(event, chartContext, config){
        var index = config.labelIndex;
        var value = config.globals.timescaleLabels[index].value;
        var value2 = config.globals.timescaleLabels[index].dateString;
        var grafica = config.globals.chartID;
  
        var fechaInicio = new Date(value2);
        var fechaFinal = new Date(fechaInicio);
        fechaFinal.setDate(fechaFinal.getDate() + 1);
        fechaFinal.setHours(0, 0, 0, 0);
        fechaFinal.setSeconds(fechaFinal.getSeconds() - 1);     
  
        if(grafica == 'Disponibilidad' && this.seriesBackDisponibilidad == null){
          this.seriesBackDisponibilidad = [...this.chartOptions1];
          this.efode = true;
        }
  
        if(grafica == 'Rendimiento' && this.seriesBackRendimiento == null){
          this.seriesBackRendimiento = [...this.chartOptions2];
          this.efore = true;
        }
  
        if(grafica == 'Calidad' && this.seriesBackCalidad == null){
          this.seriesBackCalidad = [...this.chartOptions3];
          this.efoce = true;
        }
  
        if(grafica == 'OEE' && this.seriesBackOee == null){
          this.seriesBackOee = [...this.chartOptions4];
          this.efoee = true;
        }
  
        var datosss = grafica == 'Disponibilidad' ? [this.seriesDisponibilidad[0]] : 
                        grafica == 'Rendimiento' ? [this.seriesRendimiento[0]] : 
                        grafica == 'Calidad' ? [this.seriesCalidad[0]] : 
                        grafica == 'OEE' ? [this.seriesOee[0]] : [];
  
                              
        const dataFiltrada = datosss.map(d => {
                return {
                   name: d.name,
                   data: d.data.filter(item => item.z >= fechaInicio && item.z <= fechaFinal )
                  };
                });
  
        if(this.datosBack == null) this.datosBack = [...this.datos.operaciones]
  
        if(grafica == 'Disponibilidad'){
          this.filtroDDisponibilidad = fechaInicio
          this.filtroHDisponibilidad = fechaFinal
        }
        
        if(grafica == 'Rendimiento'){
          this.filtroDRendimiento = fechaInicio
          this.filtroHRendimiento = fechaFinal
        }
  
        if(grafica == 'Calidad'){
          this.filtroDCalidad = fechaInicio
          this.filtroHCalidad = fechaFinal
        }
  
        if(grafica == 'OEE'){
          this.filtroDOee = fechaInicio
          this.filtroHOee =fechaFinal
        }
  
        this.datosFiltrada();
                    
        if(grafica == 'Disponibilidad')
           this.chartOptions1 = dataFiltrada;
        
        if(grafica == 'Rendimiento')
          this.chartOptions2 = dataFiltrada;
  
        if(grafica == 'Calidad')
          this.chartOptions3 = dataFiltrada;
        
        if(grafica == 'OEE')
          this.chartOptions4 = dataFiltrada;
                
      },
      eliminarFiltro(grafica) {
        if(grafica == 1){
          this.efode = false;
          this.chartOptions1 = [...this.seriesBackDisponibilidad];
          this.seriesBackDisponibilidad = null;
          this.filtroDDisponibilidad = null;
          this.filtroHDisponibilidad = null;
        }
        if(grafica == 2){
          this.efore = false;
          this.chartOptions2 = [...this.seriesBackRendimiento];
          this.seriesBackRendimiento = null;
          this.filtroDRendimiento = null;
          this.filtroHRendimiento = null;
        }
        if(grafica == 3){
          this.efoce = false;
          this.chartOptions3 = [...this.seriesBackCalidad];
          this.seriesBackCalidad = null;
          this.filtroDCalidad = null;
          this.filtroHCalidad = null;
        }
        if(grafica == 4){
          this.chartOptions4 = [...this.seriesBackOee];
          this.seriesBackOee = null;
          this.efoee = false;
          this.filtroDOee = null;
          this.filtroHOee = null;
        }
        this.datosFiltrada()
        if(this.filtroHDisponibilidad == null && this.filtroHRendimiento == null && this.filtroHCalidad == null && this.filtroHOee == null && this.filtroDDisponibilidad == null && this.filtroDRendimiento == null && this.filtroDCalidad == null && this.filtroDOee == null)
            this.datos.operaciones = [...this.datosBack]
      },
      datosFiltrada(){
        var arrayModificado = this.datosBack.map(objeto => {
                     var objetoModificado = { ...objeto };
                     var fI = new Date(objeto.inicioString);
                     var fF = new Date(objeto.finString);
                     objetoModificado.inicioString = fI;
                     objetoModificado.finString = fF;
                     return objetoModificado;
                  });
                  var filtrado = null;
  
        if(this.filtroDDisponibilidad != null && this.filtroHDisponibilidad != null)
          {
            console.log("Entra 1")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDDisponibilidad && item.finString <= this.filtroHDisponibilidad)}
  
        if(this.filtroDRendimiento != null && this.filtroHRendimiento != null)
          {
            console.log("Entra 2")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDRendimiento && item.finString <= this.filtroHRendimiento)}
  
        if(this.filtroDCalidad != null && this.filtroHCalidad != null)
          {console.log("Entra 3")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDCalidad && item.finString <= this.filtroHCalidad)}
  
        if(this.filtroDOee != null && this.filtroHOee != null)
          {
            console.log("Entra 4")
            filtrado = arrayModificado.filter(item => item.inicioString >= this.filtroDOee && item.finString <= this.filtroHOee)}
  
        this.datos.operaciones = filtrado;
      },
      initialize() {
        this.getTurnos();
        this.getAreas();
        this.getOTS();
        this.getArticulos();
        this.getMaquinasIns();
        this.getOperadores();
        this.getClientes();
        if(this.formulaNyx)
        {
          this.cambiarColumns()
        }
          },
      resetCampo(posicion){
        switch (posicion) {
          case 1:
            this.filtros.idsTurnos = [];
            break;
          case 2:
            this.filtros.idsAreas = [];
            break;
          case 3:
            this.filtros.idsOTS = [];
            break;
          case 4:
            this.filtros.idsArticulos = [];
            break;
          case 5:
            this.filtros.idsMaquinaInstancias = [];
            break;
          case 6:
            this.filtros.idsPersonas = [];
            break;
          case 7:
            this.filtros.idsClientes = [];
            break;
          default:
            break;
        }
      },
      stopTimer(newValue) {
        if (newValue)
          this.active = true; 
          else
          this.active = false;
      },
          obtenerDatos() {
              if (!this.realizarPeticion || this.cargando) return;
  
        if(this.modoProyeccion){
          this.filtros.idsTurnos = this.idTurnoActual;
        }
  
              this.cargando = true;
              this.segundos = 60;
        this.cargandoData = true;
              axios
              .get(this.url)
              .then((response) => {                
                this.datos = response.data;                
                
                // console.log(response.data);
                // console.log(this.datos);

                // this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                // this.serie1 = this.chartOptionsGenerador('Disponibilidad','#118dff');

                // this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                // this.serie2 = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                // this.chartOptions3 = this.generarSerie('Calidad','calidad');
                // this.serie3 = this.chartOptionsGenerador('Calidad','#10ff60');

                // this.chartOptions4 = this.generarSerie('OEE','oee');
                // this.serie4 = this.chartOptionsGenerador('OEE','#ff372b');

                // if(!this.validarNuevoReporte()){
                //   this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                //   this.serie5 = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                //   this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                //   this.serie6 = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                //   this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                //   this.serie7 = this.chartOptionsGeneradorTurno('Calidad','#6B8E23');

                //   this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                //   this.serie8 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                // }                  
                this.renderizar = true;
                this.cargando = false;
                this.cargandoData = false;
                this.viewData = true;
          
              })
              .catch((error) => {
                this.datos = this.datosDefault; 
                this.chartOptions1 = this.generarSerie('Disponibilidad','disponibilidad');
                this.serie1 = this.chartOptionsGenerador('Disponibilidad','#118dff');

                this.chartOptions2 = this.generarSerie(this.oeeRendimientoLabel,'eficiencia');
                this.serie2 = this.chartOptionsGenerador(this.oeeRendimientoLabel,'#ff8410');

                this.chartOptions3 = this.generarSerie('Calidad','calidad');
                this.serie3 = this.chartOptionsGenerador('Calidad','#10ff60');

                this.chartOptions4 = this.generarSerie('OEE','oee');
                this.serie4 = this.chartOptionsGenerador('OEE','#ff372b');

                if(!this.validarNuevoReporte()){
                  this.chartOptions5 = this.generarSerieTurno('Disponibilidad','disponibilidad');
                  this.serie5 = this.chartOptionsGeneradorTurno('Disponibilidad','#118dff');

                  this.chartOptions6 = this.generarSerieTurno(this.oeeRendimientoLabel,'eficiencia');
                  this.serie6 = this.chartOptionsGeneradorTurno(this.oeeRendimientoLabel,'#ff8410');

                  this.chartOptions7 = this.generarSerieTurno('Calidad','calidad');
                  this.serie7 = this.chartOptionsGeneradorTurno('Calidad','#10ff60');

                  this.chartOptions8 = this.generarSerieTurno('OEE','oee');
                  this.serie8 = this.chartOptionsGeneradorTurno('OEE','#ff372b');
                }
                this.cargando = false;
                this.viewData = true;
                this.cargandoData = false;
                console.log(error);
              });
        this.countVel++
          },
      getAreas() {
              axios
              .get("/Areas")
              .then((response) => {
                  this.areas = response.data.filter(a => a.idArea > 1);
              })
              .catch((error) => {
                  console.log(error);
              });
          },
          getTurnos() {
              axios
              .get("/Turnos")
              .then((response) => {
                  this.turnos = response.data;
              })
              .catch((error) => {
                  console.log(error);
              });
          },
      getOTS() {
              axios
                  .get(`/TrabajoOrdenes/TrabajoOrdenHeaders?soloEnProgreso=${false}`)
                  .then((response) => {
                      this.ots = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          },
      getArticulos() {
              axios
                  .get("/Articulos/OTS")
                  .then((response) => {
                      this.articulos = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  });
          },
      getMaquinasIns(){
        axios
        .get("/MaquinaInstancias")
        .then(response => {
          this.maquinasIns = response.data;
        })
        .catch(error => {
          console.log(error);
        })
      },
      getOperadores() {
              axios
              .get("/Personas/Operadores")
              .then((response) => {
                  this.operadores = response.data;
              })
              .catch((error) => {
                  console.log(error);
              });
          },
      getClientes(){
        axios
        .get("/Clientes")
        .then(response => {
          response.data.unshift({
            idCliente: -1,
            nombre: this.nombreEmpresa,
          });
          this.clientes = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      url2(path) {
        var url = `${path}?Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
        url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos,"IdsTurnos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsAreas,"IdsAreas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsOTS,"IdsOTS",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos,"IdsArticulos",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias,"IdsMaquinasInstancias",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas,"IdsPersonas",false);
        url += this.$utils.arrays.urlQuery(this.filtros.idsClientes,"IdsClientes",false);
        return url;
          },
      descargarReporte(){
        var datetime = moment().format('YYYYMMDDHHmmss');//OEEReport
        this.$utils.axios.downloadFile(this.url2("/OEEV2/OEEReportDetallado"),'GET','reporte-oee-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      },
      validarNuevoReporte(){
        //La unica condición con  la cual se quitaran las graficas es para el nuevo reporte OEE y que la fecha desde y hasta sean iguales
        if(this.nuevoReporteOee && this.filtros.desde==this.filtros.hasta){
          return false;
        }else{
          return true;
        }
      },
      cambiarColumns(){//Dependiendo del valor de la variable this.editedItem.iniciarAuto se cambian las columnas de la tabla
        this.headersXDia.splice(3,1,         
          {
            text: "Tiempo Ciclo",
            align: "center",
            sortable: false,
            value: "tiempoCiclo",
            // width: "50%",
          },
        ); 
      // if(this.editedItem.iniciarAuto){
        
        
      // }else {        
      //   this.headers.splice(3,1,         
      //   {
      //     text: "STD",
      //     align: "center",
      //     sortable: false,
      //     value: "std",
      //     // width: "50%",
      //   },
      //   ); 
      },           
    },
    filters: {
      formatToPercentage(value){
        return (value ).toFixed(2) + "%";//* 100
      },
      formatStringFecha(value){
        return value.slice(0,-3).split("T").join(" ");
      }
    },
      mounted() {
      // this.headers[6].text = this.oeeRendimientoLabel;
      // this.resumenDiasHeaders[3].text = this.oeeRendimientoLabel;
      if(this.modoProyeccion){
        this.filtros.desde = this.today;
        this.filtros.hasta = this.today;
        this.segundos = 0;
      }
      
          this.interval = setInterval(() => {
              if (!this.active) return;
              if(this.segundos <= 0 && this.sameDay) this.obtenerDatos();
        else this.segundos -= 1;
          }, 1000);
          this.initialize();
      },
      destroyed() {
          clearInterval(this.interval);
      },
  };
  </script>